/**
 * DebugGetCaptchaReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * DebugGetCaptchaReq
 */
export interface DebugGetCaptchaReq {
  /** 管理员用户名 */
  username: string
}

/**
 * DebugGetCaptchaReq Schema
 */
export const DebugGetCaptchaReqSchema: SchemaDefinition = {
  properties: {
    username: {
      description: '管理员用户名',
      format: 'string',
      type: 'string',
      label: '管理员用户名',
    },
  },
  required: ['username'],
  type: 'object',
}
